import { buscarClientes, buscarProjetosSelecao } from '../../../common/resources/akzo-acao-projeto';
import { buscarKpisSelecao } from '../../../common/resources/akzo-kpis-sustentabilidade';

export default {
  data() {
    return {
      akzoRelatoriosResource: this.$api.akzoRelatorios(this.$resource),
      planejamentoAcaoResource: this.$api.planejamentoAcaoCadastro(this.$resource),
      workflowAcaoResource: this.$api.workflowAcao(this.$resource),
      tipoAcaoResource: this.$api.tipoAcao(this.$resource),
      camposCustomizadosResources: this.$api.camposCustomizados(this.$resource),

      tiposInstituicao: [],
      plantas: [],
      camposFormulario: {
        padrao: [
          {
            labelCampo: 'data_inicio',
            nomCampo: this.$t('label.data_inicio'),
            tipoCampo: 'DATA',
            vlrObrigatorio: false,
          },
          {
            labelCampo: 'data_fim',
            nomCampo: this.$t('label.data_fim'),
            tipoCampo: 'DATA',
            vlrObrigatorio: false,
          },
          {
            labelCampo: 'instituicao_cliente',
            nomCampoId: 'ids_cliente',
            tipoCampo: 'LISTA',
            async: {
              fetchFunction: (autocomplete) => buscarClientes({ autocomplete }, this.$resource),
              itemValue: 'id',
              itemText: 'codNome',
            },
          },
          {
            labelCampo: 'instituicao_cor',
            tipoCampo: 'TEXTO',
          },
          {
            labelCampo: 'tipo_de_instituicao',
            nomCampoId: 'tipos_instituicao',
            tipoCampo: 'MULTIPLA_ESCOLHA',
            vlrObrigatorio: false,
            async: {
              fetchFunction: () => new Promise((resolve) => resolve({
                data: this.tiposInstituicao,
              })),
              itemValue: 'value',
              itemText: 'label',
            },
          },
          {
            labelCampo: 'nome_projeto',
            nomCampoId: 'ids_projeto',
            tipoCampo: 'MULTIPLA_ESCOLHA',
            async: {
              fetchFunction: (autocomplete) => buscarProjetosSelecao({ autocomplete }, this.$resource),
              itemValue: 'id',
              itemText: 'nomProjeto',
            },
          },
          {
            labelCampo: 'kpi',
            nomCampoId: 'ids_kpis',
            tipoCampo: 'MULTIPLA_ESCOLHA',
            async: {
              fetchFunction: (autocomplete) => buscarKpisSelecao({ autocomplete }, this.$resource),
              itemValue: 'id',
              itemText: 'nomComposto',
            },
          },
          {
            labelCampo: 'tipo_acao',
            nomCampoId: 'ids_acao_tipo',
            tipoCampo: 'MULTIPLA_ESCOLHA',
            async: {
              fetchFunction: (autocomplete) => this.tipoAcaoResource.buscarAtivos({ autocomplete }),
              itemValue: 'id',
              itemText: 'nome',
            },
          },
          {
            labelCampo: 'planta',
            nomCampoId: 'plantas',
            tipoCampo: 'MULTIPLA_ESCOLHA',
            vlrObrigatorio: false,
            async: {
              fetchFunction: () => new Promise((resolve) => resolve({
                data: this.plantas,
              })),
              itemValue: 'value',
              itemText: 'label',
            },
          },
          {
            labelCampo: 'ordem_interna',
            nomCampoId: 'ordem_interna',
            tipoCampo: 'MULTIPLA_ESCOLHA',
            async: {
              fetchFunction: (autocomplete) => this.akzoRelatoriosResource
                .buscarOrdemInternaSustentabilidade({ autocomplete }),
              itemValue: 'ordemInterna',
              itemText: 'ordemInterna',
            },
          },
        ],
      },
    };
  },
  methods: {
    carregarCamposDinamicos() {
      this.camposCustomizadosResources.listarPorEntidadeAcao()
        .then((response) => {
          this.getPlantas(response.data);
          this.getTiposInstituicao(response.data);
        }, (err) => {
          this.$error(this, err);
        });
    },
    getTiposInstituicao(result) {
      const campo = result.find((value) => value.labelCampo === 'tipo_instituicao');
      if (campo && campo.desAtributos && campo.desAtributos.value) {
        const item = {};
        Object.assign(item, JSON.parse(campo.desAtributos.value));
        item.lista.forEach((value) => {
          this.tiposInstituicao.push({ label: value, value });
        });
      }
    },
    getPlantas(result) {
      const campo = result.find((value) => value.labelCampo === 'planta');
      if (campo && campo.desAtributos && campo.desAtributos.value) {
        const item = {};
        Object.assign(item, JSON.parse(campo.desAtributos.value));
        item.lista.forEach((value) => {
          this.plantas.push({ label: value, value });
        });
      }
    },
  },
  mounted() {
    this.carregarCamposDinamicos();
  },

};
